const eye = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8.047 3C2.997 3 0 8 0 8s2.997 5 8.047 5C12.997 13 16 8 16 8s-3.003-5-7.953-5M8.5 5C10.45 5 12 6.55 12 8.5S10.45 12 8.5 12 5 10.45 5 8.5 6.55 5 8.5 5m0 1A2.507 2.507 0 0 0 6 8.5C6 9.875 7.125 11 8.5 11S11 9.875 11 8.5c0-.375-.07-.683-.196-.996a.874.874 0 0 1-.742.371.961.961 0 0 1-.938-.937c0-.312.122-.555.372-.742A2.574 2.574 0 0 0 8.499 6z"/></svg>',
};

export { eye as default };
